export default (theme) => ({
  card: {
    boxShadow: 'none',
    borderRadius: 20,
    background: '#FFF',

    '& .MuiCardContent-root': {
      height: '100%',
      minHeight: 502,
      padding: '34px 45px',
      gap: 23,

      '&:last-child': {
        paddingBottom: '34px',
      },

      [theme.breakpoints.up(768)]: {
        minHeight: 349,
      },

      [theme.breakpoints.up(1300)]: {
        minHeight: 322,
      },
    },
  },
  title: {
    color: '#49454F',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '27px',
    letterSpacing: '0.5px',

    [theme.breakpoints.up(768)]: {
      fontSize: 18,
    },

    [theme.breakpoints.up(1024)]: {
      fontSize: 24,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 23,
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,

    [theme.breakpoints.up(768)]: {
      gap: 0,
    },
  },
  text: {
    color: '#49454F',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '27px',
    letterSpacing: 0.5,

    [theme.breakpoints.up(1024)]: {
      fontSize: 18,
    },
  },
  inputs: {
    display: 'flex',
    flexDirection: 'column',
    gap: 23,
    width: '100%',

    '& .MuiInputLabel-outlined': {
      color: '#8B54F7',
    },

    '& .MuiSelect-icon': {
      fontSize: 40,
      top: 'calc(50% - 20px)',
      color: '#8B54F7',

      '&.MuiSelect-iconOpen': {
        transform: 'rotate(90deg)',
      },
    },

    '& .MuiOutlinedInput-root': {
      borderRadius: 8,

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#8B54F7',
      },
    },

    [theme.breakpoints.up(768)]: {
      flexDirection: 'row',
      gap: 24,

      '& .MuiFormControl-root:last-of-type': {
        maxWidth: 213,
      },
    },
  },
  button: {
    maxWidth: 138,

    '& .MuiButton-root': {
      padding: 0,
      borderRadius: 16,
      minHeight: 48,
      textAlign: 'center',
      fontSize: 14,
      fontWeight: 700,
      lineHeight: '16.8px',
      textTransform: 'none',
    },
  },
});
